import {Route} from "@angular/router";
import {guardAthletsEdit, guardAthletsWatch} from "@/app/routes/guards/athlets-guard";

const NAME = "Спортсмены";
export const athlets: Route[] = [
    {
        path: 'athlets',
        loadComponent: () => import('@components/guides/athletes/athlets.component').then(c => c.AthletsComponent),
        canActivate: [guardAthletsWatch],
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'athlets/create',
        loadComponent: () => import('@components/guides/athletes/create-athlet/create-athlet.component').then(c => c.CreateAthletComponent),
        canActivate: [guardAthletsEdit],
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: NAME, url: '/athlets/'},
            ],
            title: NAME
        },

    },
    {
        path: 'athlets/:id',
        canActivate: [guardAthletsWatch],
        loadComponent: () => import('@components/guides/athletes/athlets-details/athlet-details.component').then(c => c.AthletDetailsComponent),
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: NAME, url: '/athlets/'},
            ],
            title: NAME
        },

    },
]
